import { Application } from '../../blocks/common/components/application';
import { ConvertMyForm } from '../../blocks/common/applications/convert-my-form';
import { GoDigital } from '../../blocks/pages/mobile-forms/go-digital';
import { DoItForYou } from '../../blocks/pages/mobile-forms/do-it-for-you';
import { DigitalConversion } from '../../blocks/pages/mobile-forms/digital-conversion';
import { HowItWorks } from '../../blocks/pages/mobile-forms/how-it-works';
import { MobileFormsBenefits } from '../../blocks/pages/mobile-forms/mobile-forms-benefits';
import { MobileFormsFeatures } from '../../blocks/pages/mobile-forms/mobile-forms-features';
import { ExamplesOfMobileForms } from '../../blocks/pages/mobile-forms/examples-of-mobile-forms';
import { MoreQuestions } from '../../blocks/pages/mobile-forms/more-questions';


class Main extends Application {
    async init() {
        await super.init();

        const goDigital = new GoDigital();
        goDigital.init(this.store);

        const doItForYou = new DoItForYou();
        doItForYou.init(this.store);

        const digitalConversion = new DigitalConversion();
        digitalConversion.init(this.store);

        const howItWorks = new HowItWorks();
        howItWorks.init(this.store);

        const mobileFormsBenefits = new MobileFormsBenefits();
        mobileFormsBenefits.init(this.store);

        const mobileFormsFeatures = new MobileFormsFeatures();
        mobileFormsFeatures.init(this.store);

        const examplesOfMobileForms = new ExamplesOfMobileForms();
        examplesOfMobileForms.init(this.store);

        const moreQuestions = new MoreQuestions();
        moreQuestions.init(this.store);
        
        const convertMyForm = new ConvertMyForm();
        convertMyForm.init(this.store);

    }
}

const application = new Main();
application.init();
window['application'] = application;